import timeago from 'vue-timeago3';
import { enUS, fr } from 'date-fns/locale';
import touch from 'vue3-hand-mobile';

export const registerTimeAgo = (Vue, locale = 'en-US') => {
  // FIXME: This is not really scable for mulitple languages.
  // Since this is only for timeago component, we can revisit
  // and make this component more generic later.
  locale = locale.includes('fr') ? fr : enUS;

  const timeagoOptions = {
    locale,
  };
  Vue.use(timeago, timeagoOptions);
  Vue.use(touch);
};

export default {
  registerTimeAgo,
};
